import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

const TicketPageLoading = ({ message = 'Loading ticket form…' }) => (
  <Box
    data-testid="ticket-page-loading"
    sx={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 2
    }}
  >
    <CircularProgress size={40} aria-label="Loading" />
    <Typography variant="body1" color="text.secondary" role="status" aria-live="polite">
      {message}
    </Typography>
  </Box>
);

TicketPageLoading.propTypes = {
  message: PropTypes.string
};

export default TicketPageLoading;
